<template>
  <div>
  <a-modal :zIndex="10000" v-if="roiVisible" :visible="roiVisible" :footer="null" width="765px" :maskClosable="false"
    @cancel="close">
    <div class="bg-white rounded-lg p-8">
      <!-- 标题区域 -->
      <div class="flex justify-between items-center mb-8">
        <h1 class="text-2xl font-medium text-gray-900">批量去水印</h1>
      </div>

      <!-- 输入区域 -->
      <div class="space-y-6">
        <a-form :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" labelAlign="left">
          <a-form-item label="" style="margin-bottom: 0px;">
            <a-textarea v-model="batch_video_url" @change="getBatchUrl" placeholder="输入视频/图文链接,多条视频请换行"
              style="width: 100%" :auto-size="{ minRows: 3, maxRows: 3 }" :allowClear="true" />
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 5px;text-align: right;">
            <a-button type="primary" style="width: 100%" @click="checkSearchAll">开始全部解析</a-button>
          </a-form-item>

        </a-form>


        <a-spin :spinning="loading" tip="加载中...">
          <div v-if="batch_video_url && batch_url_list.length > 0" style="max-height: 600px;overflow-y: auto">
            <div v-for="(item, index) in batch_url_list" :key="index">
              <div style="line-height: 40px;text-align: left;position:relative">
                <b
                  style="display:block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;width: 420px;">链接{{ index + 1 }}：{{
                  item.url }}</b>
                <a v-if="item.status == -1" @click="retry(index)" style="position:absolute;left:430px;top:0px;">再次解析</a>
                <span @click="clearSearchList(index)"
                  style="position:absolute;right:20px;color:red;cursor:pointer;top:0px">移除</span>
              </div>
              <div class="select-video" v-if="item.status == 1">
                <div class="left">
                  <img :src="item.origin_cover" />
                </div>
                <div class="right">
                  <div class="item_title">视频标题：{{ item.title }}</div>
                  <div class="item_id">视频ID：{{ item.group_id_str }}</div>
                  <div class="awemeinfo">
                    抖音号：{{ item.nickname }}(UID:{{ item.uid }})
                  </div>
                  <!-- <a :href="item.video_url" target="_blank" style="color: red;cursor: pointer;">下载视频</a> -->
                  <a-button class="download-btn" type="primary" @click="downloadVideo(item)">复制地址</a-button>
                </div>
              </div>
              <div class="select-video"  v-else-if="item.status == 0">
                <div class="empty" style="border: 1px dashed #333;">
                  <div>
                    <a-icon type="clock-circle" />
                    待解析
                  </div>
                </div>
              </div>
              <div class="select-video"  v-else-if="item.status == 2">
                <div class="empty" style="color:green">
                  <div>
                    <a-icon type="clock-circle" />
                    正在解析
                  </div>
                </div>
              </div>
              <div class="select-video"  v-else-if="item.status == -1">
                <div class="empty">
                  <div style="color:red">
                    <a-icon type="close-circle" />
                    解析失败请重试
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="empty" v-else>
            <div><a-icon type="video-camera" /> 输入视频链接搜索后显示</div>
          </div>
        </a-spin>
        <span class="foot_tip">（ 可从抖音APP上找到对应的视频点击右下角复制链接粘贴到此处 ）</span>


      </div>
    </div>
  </a-modal>

  <!-- Video Player Modal -->
  <a-modal
    :zIndex="20000" 
    :visible="videoModalVisible"
    title="视频预览"
    :footer="null"
    width="800px"
    @cancel="videoModalVisible = false"
  >
    <video
      v-if="strUrl"
      :src="strUrl"
      controls
      autoplay
      style="width: 100%;"
    ></video>
  </a-modal>
  </div>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';
export default {
  name: 'action',
  props: {
  },
  data() {
    return {
      roiVisible: true,
      returnRateVisible: false,
      searchBatchVisible: false,
      batch_video_url: '',
      batch_url_list: [],
      loading:false,
      strUrl:'',
      videoModalVisible: false,
    };
  },

  components: {
  },

  watch: {},
  mounted() {

  },
  methods: {
    downloadVideo(item){
      console.log(item.video_url)
      const strUrl = item.video_url; 
      this.strUrl = strUrl;
      // this.videoModalVisible = true;
      this.$emit('copyWatermark',strUrl)
    },
    getBatchUrl() {
      let list = this.batch_video_url.split('\n');
      let data = []
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          data.push({
            url: list[i],
            origin_cover: '',
            title: '',
            group_id_str: '',
            nickname: '',
            uid: '',
            status: 0,
          })
        }
      }
      this.batch_url_list = data
    },
    async checkSearchAll() {
      this.loading = true
      for (let i = 0; i < this.batch_url_list.length; i++) {
        this.batch_url_list[i].status = 2
        let video_url = this.batch_url_list[i].url;
        //1.从抖音复制过来的内容里提取url
        var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
        let urlexec = reg.exec(video_url)
        let url = ''
        let type = 'url'
        if (urlexec) {
          url = urlexec[0]
        }
        //2.用户直接输入视频链接
        if (/^[0-9]*$/.test(video_url.replace(' ', ''))) {
          url = video_url.replace(' ', '')
          type = 'id';
        }
        //3.用户直接输入链接
        if (video_url.indexOf("https://www.douyin.com/video/") != -1) {
          url = video_url.replace('https://www.douyin.com/video/', '');
          url = url.replace(' ', '')
          type = 'id';
        }
        //4.用户直接输入链接
        if (video_url.indexOf("https://www.douyin.com/note/") != -1) {
          url = video_url.replace('https://www.douyin.com/note/', '');
          url = url.replace(' ', '')
          type = 'image';
        }
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.SXT_SEARCH_VIDEO}`,
          method: 'POST',
          params: {
            url: url,
            type: type,
          },
        });
        this.loading = false
        if (code == 0) {
          this.batch_url_list[i].status = -1
        } else {
          if (data.title) {
            this.batch_url_list[i].status = 1
            this.batch_url_list[i].title = data.title
            this.batch_url_list[i].origin_cover = data.origin_cover
            this.batch_url_list[i].group_id_str = data.group_id_str
            this.batch_url_list[i].nickname = data.nickname
            this.batch_url_list[i].uid = data.uid
            this.batch_url_list[i].video_url = data.video_url
          } else {
            this.batch_url_list[i].status = -1
          }
        }
      }
    },
    async retry(i) {
      this.batch_url_list[i].status = 2
      let video_url = this.batch_url_list[i].url;
      //1.从抖音复制过来的内容里提取url
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
      let urlexec = reg.exec(video_url)
      let url = ''
      let type = 'url'
      if (urlexec) {
        url = urlexec[0]
      }
      //2.用户直接输入视频链接
      if (/^[0-9]*$/.test(video_url.replace(' ', ''))) {
        url = video_url.replace(' ', '')
        type = 'id';
      }
      //3.用户直接输入链接
      if (video_url.indexOf("https://www.douyin.com/video/") != -1) {
        url = video_url.replace('https://www.douyin.com/video/', '');
        url = url.replace(' ', '')
        type = 'id';
      }
      //4.用户直接输入链接
      if (video_url.indexOf("https://www.douyin.com/note/") != -1) {
        url = video_url.replace('https://www.douyin.com/note/', '');
        url = url.replace(' ', '')
        type = 'image';
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_SEARCH_VIDEO}`,
        method: 'POST',
        params: {
          url: url,
          type: type,
        },
      });
      if (code == 0) {
        this.batch_url_list[i].status = -1
      } else {
        if (data.title) {
          this.batch_url_list[i].status = 1
          this.batch_url_list[i].title = data.title
          this.batch_url_list[i].origin_cover = data.origin_cover
          this.batch_url_list[i].group_id_str = data.group_id_str
          this.batch_url_list[i].nickname = data.titlenickname
          this.batch_url_list[i].uid = data.uid
        } else {
          this.batch_url_list[i].status = -1
        }
      }
    },
    clearSearchList(index) {
      this.batch_url_list = this.batch_url_list.filter(function (item, i) {
        return index != i
      })
    },
    close() {
      this.$emit('close')
      return;
    }
  },
};
</script>

<style lang="less" scoped>
.dqtitle {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #fe346e;
  margin-bottom: 20px
}

.dqtag {
  font-size: 14px;
  color: #333;
  text-align: left;
  font-weight: bold;
}

.dqbtn {
  width: 85%;
  margin: 0 auto;
  margin-top: 20px;

  button {
    margin-bottom: 10px;
    width: 100%
  }
}
.select-video {
  border: 1px dashed #c1c1c1;
  border-radius: 4px;
  width: 648px;
  height: 110px;
  background-color: #fff;
  cursor: pointer;
  line-height: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #333;

  .left {
    float: left;
    width: 100px;

    img {
      width: 70px;
      height: 85px;
      border-radius: 3px;
      cursor: pointer;
      margin: 10px;
    }
  }

  .right {
    float: left;
    width: 540px;
    padding: 10px 0px;
    position: relative;

    .item_title {
      margin-top: 5px;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      width: 450px;
    }

    .item_id {
      margin-top: 10px;
      text-align: left;
      font-size: 14px;
    }
    .span {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #194ce5;
    }
    .check {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #194ce5;
    }
    .awemeinfo {
      font-size: 14px;
      text-align: left;
      margin-top: 10px;
    }
  }
}
.empty {
  display: grid; 
  border-radius: 4px;
  width: 648px;
  height: 110px; 
  cursor: pointer;
  line-height: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  letter-spacing: 2px;
  place-items: center;
  border: 1px dashed #333;
}
.foot_tip {
  display: block;
  margin-top: 20px;
}
.download-btn{
  position: absolute;
  right: 10px;
  bottom: 10px;
}
</style>